<template>
  <div>
    <div>
      <h2 class="title">加入须知</h2>
      <p>欢迎您使用共享备件社区服务！</p>
      <p>
        【审慎阅读】您在按照页面提示确认同意本协议之前，应当认真阅读本协议。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决等以粗体下划线标识的条款。如您对协议有任何疑问，可向共享备件客服咨询。
      </p>
      <p>
        【签约动作】当您按照页面提示同意本协议且完成服务开通流程后，即表示您已充分阅读、理解并接受本协议的全部内容，并与共享备件达成一致，成为共享备件社区的“用户”。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止使用共享备件社区服务。
      </p>
      <p>
        本协议由您与共享备件社区经营者浙江工自仪网络有限公司（本协议中可称“共享备件”或“我们”）共同签署。
      </p>
      <p>
        一、 定义
      </p>
      <p>
        1.1 共享备件社区：共享备件为用户提供便捷交易服务的在线闲置工业品交流社区，包括域名为“plantmate.com”的共享备件网站、移动客户端等（包括未来技术发展出现的新的服务形态，以下可统称“社区”，其中域名及名称可能根据实际情况进行修改，届时以最新内容为准）。
      </p>
      <p>
        1.2 共享备件社区规则：包括在共享备件社区规则频道内已经发布及后续发布的全部规则、解读、公告等内容以及在共享备件论坛、帮助中心内发布的各类规则、实施细则、产品流程说明、公告等，具体详见“共享备件APP-我的-共享备件公约”。
      </p>
      <p>
        二、 账户使用
      </p>
      <p>
        2.1 【用户资格】您确认，在您开始使用共享备件社区服务前，您所在的企业已在PLANTMATE平台上进行企业注册并认证。
      </p>
      <p>
        2.2【账户说明】鉴于共享备件社区服务系基于您的PLANTMATE平台账户为您提供，您有权使用您的PLANTMATE平台账户登录共享备件社区并使用相关服务。
      </p>
      <p>
        由于您的账户关联您的个人及企业信息及共享备件社区商业信息，您的账户仅限您本人及企业使用。未经共享备件社区同意，您直接或间接授权第三方使用您账户或获取您账户项下信息的行为无效。
      </p>
      <p>
        作为共享备件社区经营者，为使您更好地使用共享备件社区的各项服务，保障您的账户安全，共享备件可要求您按相关法律法规规定及共享备件/浙江工自仪网络有限公司要求完成实名认证以及企业认证。
      </p>
      <p>
        2.3【账户信息管理】在使用共享备件社区服务时，您应当按页面提示准确完整地提供您的信息（包括您的联系电话、联系地址等），以便共享备件或其他用户与您联系。您了解并同意，您有义务保持您提供信息的真实性、有效性并及时更新。在法律有明确规定要求共享备件作为服务提供者须对用户信息进行核实的情况下，共享备件将依法不时地对您的信息进行核实，您应当配合提供最新、真实、完整、有效的信息。
      </p>
      <p>
        2.4【账户行为责任自负】除共享备件存在过错外，您应对基于您的账户在共享备件社区内产生的所有行为结果（包括但不限于在线签署各类协议、发布信息、购买商品及服务及披露信息等）负责。
      </p>
      <p>
        三、 共享备件社区服务及规范
      </p>
      <p>
        【服务概况】您有权在共享备件社区上享受闲置工业备件信息的浏览、收藏、购买与评价、交易争议处理、信息交流等服务。共享备件提供的服务（即我们通过共享备件社区向用户提供的服务，下同）内容众多，具体您可登录共享备件社区浏览。
      </p>
      <p>
        3.1 闲置工业备件/服务信息的浏览、收藏
      </p>
      <p>
        在您浏览共享备件社区的过程中，共享备件为您提供了信息分类、关键词检索、筛选、收藏及关注等功能，以更好地匹配您的需求。
      </p>
      <p>
        3.2 发布闲置工业备件/服务等信息
      </p>
      <p>
        3.2.1【备件发布】通过共享备件提供的服务，您可通过文字、图片、视频等形式在共享备件社区内直接发布闲置工业备件/服务信息等。您声明并保证，您对您所发布的信息拥有相应、合法的权利，您所发布的信息及实施的行为均符合相关法律法规、国家强制性标准要求及本协议约定，并且您对您发布的信息负有管理义务，对其中您违反相关法律法规规定及本协议约定的信息应立即删除，否则，共享备件可对您发布的信息及账户依法或依本协议采取必要处置措施。
      </p>
      <p>
        3.2.2【禁止性信息】您应当确保您所发布的信息不包含以下内容：
      </p>
      <p>
        （一）违反国家法律法规禁止性规定的内容；<br />
        （二）政治宣传、封建迷信、淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的内容；<br />
        （三）欺诈、虚假、不准确或存在误导性的内容；<br />
        （四）侵犯他人知识产权或涉及第三方商业秘密及其他专有权利的内容；<br />
        （五）侮辱、诽谤、恐吓、涉及他人隐私等侵害他人合法权益的内容；<br />
        （六）存在可能破坏、篡改、删除、影响共享备件社区任何系统正常运行或未经授权秘密获取共享备件及其他用户的数据、个人资料的病毒、木马、爬虫等恶意软件、程序代码的内容；<br />
        （七）其他违背社会公共利益或公共道德或依据共享备件社区相关协议、规则的规定不适合在社区内发布的内容。
      </p>
      <p>
        3.3 备件的交易与评价
      </p>
      <p>
        【备件的购买】当您在共享备件社区购买闲置工业备件时，请您务必与卖方仔细确认商品的品牌、价格、数量、使用程度、瑕疵等重要事项，并在下单时核实您的联系地址、电话、收货人等信息。此外，您不得实施恶意购买、恶意维权等扰乱共享备件社区正常交易秩序的行为。基于维护共享备件社区交易秩序及交易安全的需要，共享备件发现上述情形时可主动执行关闭相关订单等操作。
      </p>
      <p>
        【备件的支付及收款】共享备件/浙江工自仪网络有限公司不提供备件的支付及收款担保服务，买卖双方自行约定交易金额及形式。
      </p>
      <p>
        3.4 交易争议处理
      </p>
      <p>
        【交易争议处理途径】您在共享备件社区交易过程中与其他用户发生争议的，您或其他用户中任何一方均有权选择以下途径解决：
      </p>
      <p>
        （一）与争议相对方自主协商；<br />
        （二）请求依法成立的相关调解组织调解；<br />
        （三）向有关行政部门投诉；<br />
        （四）根据与争议相对方达成的仲裁协议（如有）提请仲裁机构仲裁；<br />
        （五）向人民法院提起诉讼。
      </p>
      <p>
        3.5 贸易限制
      </p>
      <p>
        针对通过共享备件社区取得的商品、服务、软件及技术（包括共享备件社区提供的软件及技术），您承诺遵守所有适用的进出口管制、贸易限制与经济制裁等相关法律法规。
      </p>
      <p>
        3.6 费用
      </p>
      <p>
        共享备件为共享备件社区向您提供的服务付出了大量成本，除共享备件社区明示的收费业务外，共享备件向您提供的服务目前是免费的。如未来共享备件向您收取合理费用，共享备件会采取合法途径并在合法期限内提前通过法定程序并以本协议约定的方式通知您，确保您有充分选择的权利。
      </p>
      <p>
        3.7 责任限制
      </p>
      <p>
        【不可抗力及第三方原因】共享备件依照法律规定履行基础保障义务，但对于下述原因导致的合同履行障碍、履行瑕疵、履行延后或履行内容变更等情形，共享备件不承担相应的违约责任：
      </p>
      <p>
        （一）自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；<br />
        （二）电力供应故障、通讯网络故障等公共服务因素或第三人因素；<br />
        （三）在共享备件已尽善意管理义务的情况下，常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。
      </p>
      <p>
        【海量信息】共享备件仅向您提供共享备件社区服务，您了解共享备件社区内的信息系用户自行发布，且可能存在风险和瑕疵。共享备件将通过依法建立相关检查监控制度，尽可能保障您在共享备件社区上的合法权益及良好体验。同时，鉴于共享备件社区具备存在海量信息及信息网络环境下信息与实物相分离的特点，共享备件无法逐一审查备件的信息，无法逐一审查交易所涉及的备件的质量、安全以及合法性、真实性、准确性，对此您应谨慎判断。
      </p>
      <p>
        【交易纠纷风险】您知悉并了解闲置工业备件/服务交易纠纷及风险高于全新物品/服务交易，您需在共享备件内对交易细节进行详细、客观的沟通约定，并遵守相应的约定事项。若因交易约定不详导致的交易纠纷，除法律另有明确规定外，由您自行承担风险。此外，您知悉并了解线下见面交易存在较大的人身财产安全及交易纠纷风险，如因线下见面交易产生纠纷及风险，除法律另有明确规定外，由您自行承担。
      </p>
      <p>
        【调处决定】您理解并同意，在社区争议调处服务中，共享备件及其员工、小法庭评审员等用户或合作方并非专业机构、人士，仅能以普通人的认知对用户提交的凭证进行判断。因此，共享备件不保证争议处理结果符合您的期望，除存在故意或重大过失外。
      </p>
      <p>
        3.8 责任限制
      </p>
      <p>
        【不可抗力及第三方原因】共享备件依照法律规定履行基础保障义务，但对于下述原因导致的合同履行障碍、履行瑕疵、履行延后或履行内容变更等情形，共享备件不承担相应的违约责任：
      </p>
      <p>
        （一）自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；<br />
        （二）电力供应故障、通讯网络故障等公共服务因素或第三人因素；<br />
        （三）在共享备件已尽善意管理义务的情况下，常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。
      </p>
      <p>
        四、用户信息的保护及授权
      </p>
      <p>
        4.1 个人信息的保护
      </p>
      <p>
        共享备件非常重视用户个人信息的保护，在您使用共享备件提供的服务时，您同意共享备件按照在共享备件社区上公布的隐私权政策收集、存储、使用、披露和保护您的个人信息。
      </p>
      <p>
        4.2 非个人信息的授权
      </p>
      <p>
        【授权使用】对于您提供、发布及在使用共享备件社区服务中形成的除个人信息外的文字、图片、视频、音频等非个人信息，均不会因上传、发布等行为发生知识产权、肖像权等权利的转移。除非我们另行说明。在法律允许的范围内，您免费授予共享备件及其关联公司非排他的、无地域限制的许可使用（包括存储、使用、复制、修订、编辑、发布、展示、翻译、分发上述信息或制作派生作品，以已知或日后开发的形式、媒体或技术将上述信息纳入其它作品内等）、再许可第三方使用的权利，以及可以自身名义对第三方侵权行为取证及提起诉讼的权利。
      </p>
      <p>
        五、 用户的违约及处理
      </p>
      <p>
        5.1 违约认定
      </p>
      <p>
        发生如下情形之一的，视为您违约：
      </p>
      <p>
        （一）使用共享备件社区服务时违反有关法律法规规定的；<br />
        （二）违反本协议约定的。<br />

      </p>
      <p>
        为适应共享备件社区发展和满足海量用户对高效优质服务的需求，您理解并同意，共享备件可在共享备件社区规则中约定违约认定的程序和标准。如：共享备件可依据您的用户数据与海量用户数据的对比，认定您是否构成违约；您有义务对您的数据异常现象进行充分举证和合理解释，否则将被认定为违约。
      </p>
      <p>
        5.2 违约处理措施
      </p>
      <p>
        【信息处理】您在共享备件社区内发布的信息构成违约的，共享备件可根据相应规则立即对相应信息进行删除、屏蔽处理。
      </p>
      <p>
        【行为限制】您在共享备件社区内实施的行为，或虽未在共享备件社区上实施但对共享备件社区及其用户产生影响的行为构成违约的，共享备件可依据相应规则对您执行账户扣分、中止向您提供部分或全部服务等处理措施。如您的行为构成根本违约的，您同意共享备件可查封您的账户并终止向您提供服务，您将无法再基于您的账户登录使用相关服务。
      </p>
      <p>
        【处理结果公示】共享备件可将对您上述违约行为处理措施信息以及其他经国家行政或司法机关生效法律文书确认的违法信息在共享备件社区内予以公示，公示信息包括您账号名称、违约、违法行为、处理结果等。
      </p>
      <p>
        5.3 赔偿责任
      </p>
      <p>
        如您的行为使共享备件及/或其关联公司、浙江工自仪网络有限公司遭受损失（包括对外支付的违约金、赔偿款、和解款、罚款、律师费、诉讼费、商誉损失等直接经济损失及间接经济损失）或遭受第三人主张权利而对第三人承担金钱给付等义务的，您应赔偿共享备件及/或其关联公司、浙江工自仪网络有限公司的上述全部损失。
      </p>
      <p>
        5.4 特别约定
      </p>
      <p>
        【关联处理】如您因严重违约导致共享备件终止本协议时，出于维护平台秩序及保护消费者权益的目的，共享备件及/或其关联公司可对与您在其他协议项下的合作采取中止甚或终止协议的措施，并以本协议及/或共享备件及其关联公司与您约定的方式通知您。
      </p>
      <p>
        如共享备件与您签署的其他协议及共享备件及/或其关联公司、浙江工自仪网络有限公司与您签署的协议中明确约定了对您在本协议项下合作进行关联处理的情形，则共享备件出于维护平台秩序的目的，可在收到指令时中止甚至终止协议，并以本协议约定的方式通知您。
      </p>
      <p>
        六、 通讯方式
      </p>
      <p>
        6.1 有效联系方式
      </p>
      <p>
        您在同意成为共享备件用户并接受共享备件社区服务时，您应该向共享备件提供真实有效的联系方式（包括您的电子邮件地址、联系电话、联系地址等），对于联系方式发生变更的，您有义务及时更新有关信息，并保持可被联系的状态。
      </p>
      <p>
        您在登录共享备件社区所使用的接收站内信、系统消息和即时信息的账户，也作为您的有效联系方式。
      </p>
      <p>
        共享备件将向您的上述联系方式的其中之一或若干向您送达各类通知，而此类通知的内容可能对您的权利义务产生重大的有利或不利影响，请您务必及时关注。
      </p>
      <p>
        您有权通过您账户绑定的手机号码或者电子邮箱获取您感兴趣的商品广告信息、促销优惠等商业性信息；您如果不愿意接收此类信息，您有权通过共享备件提供的退订功能进行退订。
      </p>
      <p>
        6.2 通知的送达
      </p>
      <p>
        共享备件通过上述联系方式向您发出通知，其中以电子信息方式发出的书面通知，包括但不限于在共享备件社区公告，向您提供的联系电话发送手机短信，向您提供的电子邮件地址发送电子邮件，向您的账号发送信息，在发送成功后即视为送达；以纸质载体发出的书面通知，按照提供联系地址交邮后的第五个自然日即视为送达。
      </p>
      <p>
        对于在共享备件社区内因交易活动引起的任何纠纷，您同意司法机关（包括但不限于人民法院）可以通过手机短信、电子邮件或邮寄方式向您送达法律文书（包括但不限于诉讼文书）。您指定接收法律文书的手机号码、电子邮箱或账户等联系方式为您账户注册或更新时提供的手机号码、电子邮箱联系方式，司法机关向上述联系方式发出法律文书即视为送达。您指定的邮寄地址为您的法定联系地址或您提供的有效联系地址。
      </p>
      <p>
        您同意司法机关可采取以上一种或多种送达方式向您达法律文书，司法机关采取多种方式向您送达法律文书，送达时间以上述送达方式中最先送达的为准。
      </p>
      <p>
        您同意上述送达方式适用于司法程序的各个阶段。如进入诉讼程序的，包括但不限于一审、二审、再审、执行以及督促程序等。
      </p>
      <p>
        你应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不准确，或未及时更新、告知变更后的联系方式，致使法律文书无法送达或未及时送达，由您自行承担由此可能产生的法律后果。
      </p>
      <p>
        七、 协议的终止
      </p>
      <p>
        7.1 终止的情形
      </p>
      <p>
        【用户发起的终止】您有权通过以下任一方式终止本协议：
      </p>
      <p>
        （一）在满足共享备件社区公示说明的账户注销条件时，您通过网站自助服务注销您的账户的；<br />
        （二）变更事项生效前您停止使用并明示不愿接受变更事项的；<br />
        （三）您明示不愿继续使用共享备件社区服务，且符合服务终止条件的。
      </p>
      <p>
        【共享备件发起的终止】出现以下情况时，共享备件可以本协议约定的方式通知您终止本协议：
      </p>
      <p>
        （一）您违反本协议约定，共享备件依据违约条款终止本协议的；<br />
        （二）如您在线签署的《PLANTMATE平台服务协议》因任何原因终止，则本协议将同时终止。<br />
        （三）您在PLANTMATE平台有欺诈、发布或销售假冒伪劣/侵权商品、侵犯他人合法权益或其他严重违法违约行为的；<br />
        （四）其它应当终止服务的情况。
      </p>
      <p>
        7.2 协议终止后的处理
      </p>
      <p>
        【用户信息披露】本协议终止后，除法律有明确规定外，共享备件无义务向您或您指定的第三方披露您账户中的任何信息。
      </p>
      <p>
        【共享备件权利】本协议终止后，在法律允许的范围内，共享备件仍享有下列权利：
      </p>
      <p>
        （一）继续保存您留存于共享备件社区的本协议第五条所列的各类信息；<br />
        （二）对于您过往的违约行为，共享备件仍可依据本协议向您追究违约责任。
      </p>
      <p>
        【交易处理】本协议终止后，对于您在本协议有效期间内产生的交易订单，共享备件可通知交易相对方并根据交易相对方的意愿决定是否关闭该等交易订单；如交易相对方要求继续履行的，则您应当就该等交易订单继续履行本协议及交易订单的约定，并承担因此产生的任何损失或增加的任何费用。
      </p>
      <p>
        八、 法律适用与管辖
      </p>
      <p>
        【法律适用】本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国大陆地区法律；如法律无相关规定的，参照商业惯例及/或行业惯例。
      </p>
      <p>
        【管辖】您因使用共享备件社区服务所产生及与共享备件社区服务有关的争议，由共享备件与您协商解决。协商不成时，任何一方均可向被告所在地有管辖权的人民法院提起诉讼。
      </p>
      <p>
        九、其他
      </p>
      <p>
        【可分性】本协议任一条款被视为废止、无效或不可执行，该条款应视为可分的，且并不影响本协议其余条款的有效性及可执行性。
      </p>
      <p>
        【协议指向】本协议为《共享备件用户服务协议》的修订版本，自本协议发布之日起，共享备件社区各处所称“共享备件用户服务协议”均指本协议。
      </p>
      <p>
        【索引说明】各条款前所列索引关键词仅为帮助您理解该条款表达的主旨之用，不影响或限制本协议条款的含义或解释。
      </p>
    </div>
    <div class="row fixedRow" id="agreeLine">
      <el-row>
        <el-col :span="12">
          &nbsp;
          <!-- <div class="agree">
            <el-checkbox v-model="checked" v-show="showControl">同意</el-checkbox>&nbsp;
          </div> -->
        </el-col>
        <el-col :span="12">
          <div class="btns">
            <el-button @click="clickCancel">取消</el-button>
            <el-button type="primary" :loading="loading" @click="clickJoinIn" v-show="showControl">同意并加入</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  props: ['showControl'],
  data () {
    return {
      checked: false,
      loading: false
    }
  },
  methods: {
    clickJoinIn () {
      this.loading = true
      let params = {
        companyId: this.$store.state.user.defaultCompanyId
      }
      // this.$emit('joinSuccess')
      this.$http.post(`/front/user/sys/custCompany/joinNotice`, params)
        .then(({ data }) => {
          this.loading = false
          this.$emit('joinSuccess')
          this.$message.success('加入成功！')
        })
        .catch(() => {
          this.loading = false
        })
    },
    clickCancel () {
      if (this.showControl) {
        this.$router.go(-1)
      } else {
        this.$emit('joinSuccess')
      }
    },
    scrollMethod () {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 3800) {
        let div = document.getElementById('agreeLine')
        div.classList.remove('fixedRow')
      } else {
        let div = document.getElementById('agreeLine')
        if (!div.classList.contains('fixedRow')) {
          div.classList.add('fixedRow')
        }
      }
    }
  },
  mounted () {
    window.addEventListener('scroll', this.scrollMethod)
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollMethod)
  }
}
</script>

<style lang="scss" scoped>
.title {
  text-align: center;
}
.agree {
  line-height: 40px;
}
.btns {
  text-align: right;
}
.row {
  background: #fff;
}
.fixedRow {
  position: fixed;
  bottom: 0;
  width: 1150px;
  border: 1px solid #ccc;
  border-radius: 6px 6px 0 0;
  padding: 10px;
}
</style>
